import styled from "styled-components";

export const Styles = styled.div<{ enablePanning?: boolean }>`
  width: 100%;
  height: 100%;

  .react-transform-wrapper {
    width: 100% !important;
    height: 100% !important;
    user-select: text;
    -webkit-user-select: text;
    cursor: ${(props) => (props.enablePanning ? "grab" : "default")};

    &:active {
      cursor: ${(props) => (props.enablePanning ? "grabbing" : "default")};
    }
  }

  .react-transform-component {
    width: 100% !important;
    height: 100% !important;
    user-select: text;
    -webkit-user-select: text;
  }
`;
